import { useState } from "react";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { ConfirmDialog } from "@/components/common/Dialog";
import { showSuccessToast } from "@/hooks/use-toast";
import { WebhookSearch } from "@/types/domain";
import { LoadingOverlay } from "@/components/common/Loading/LoadingOverlay";
import { deleteWebhook } from "@/api/webhook";

export type DeleteWebhookDialogProps = {
  webhook: WebhookSearch;
  callBack: () => Promise<void>;
};

export const DeleteWebhookDialog = ({
  webhook,
  callBack,
}: DeleteWebhookDialogProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  let triggerTitle = "Delete this webhook";

  const handleOpenChange = (open: boolean) => {
    setDialogOpen(open);
    setError(null);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    setError(null);
    try {
      await deleteWebhook(webhook.id);
      // error for any reason will throw and be caught below
      showSuccessToast("Webhook deleted successfully.");
      setDialogOpen(false);
      await callBack();
    } catch (err) {
      setError("Failed to delete webhook.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoadingOverlay isVisible={loading} message="Deleting Webhook..." />
      <ConfirmDialog
        open={dialogOpen}
        onOpenChange={handleOpenChange}
        triggerIcon={faTrashCan}
        triggerText=""
        triggerVariant="icon"
        disableTrigger={false}
        triggerTitle={triggerTitle}
        title="Delete Webhook"
        description={
          <>
            Are you sure you want to delete <strong>{webhook.url}</strong>?
            <br />
            This action cannot be undone.
            {error && <div className="text-red-500 text-sm mt-2">{error}</div>}
          </>
        }
        confirmText="Delete"
        cancelText="Cancel"
        loading={loading}
        onConfirm={handleConfirmDelete}
        disableConfirm={loading}
      />
    </>
  );
};
